const prefix = 'src/redux/administrations/'

export const GET_ADMINISTRATION_CANDIDATE_LIST = `${prefix}candidate-list/get`
